import React, {Component, ReactElement} from 'react'
import Http from '../../../../network/Http'

interface Props {
    contents: string
}

interface States {
    staticContents: string,
}

export default class NatResidentStaticContentsComponent extends Component<Props, States> {
    http: Http;

    constructor(props: Props) {
        super(props);
        this.state = {
            staticContents: '',
        };
        this.http = new Http();
    }

    async componentDidMount(): Promise<void> {
        // 静的コンテンツ取得
        const contents: string = await this.http.getHtmlContents(this.props.contents);
        this.setState({staticContents: contents})
    }

    componentDidUpdate(prevProps: Props, prevState: States): void {
        if (prevState.staticContents !== this.state.staticContents && this.state.staticContents) {
            const hashTag = window.location.hash.slice(1);
            if (hashTag) {
                const hashTagElement = document.getElementById(hashTag);
                if (hashTagElement) {
                    setTimeout(() => {
                        hashTagElement.scrollIntoView()
                    }, 1000)
                }
            }
        }
    }

    render(): ReactElement {
        return (
            <div dangerouslySetInnerHTML={{__html: this.state.staticContents}}></div>
        )
    }
}
